import Vue from 'vue'
import Router from 'vue-router'
import Listing from '@/components/Listing'
import Maintenance from '@/components/Maintenance'
import TranslateAPI from '@/translate-api'

Vue.use(Router)
Vue.use(TranslateAPI)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Listing',
      component: Listing
    },
    {
      path: '/manutencao',
      name: 'Maintenance',
      component: Maintenance
    }
    // {
    //   path: '*',
    //   redirect: '/'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js